import {
    Component,
    ChangeDetectionStrategy,
    OnInit,
    ViewChild,
    ChangeDetectorRef,
    OnDestroy
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { SellingTypeEnum } from '@classifieds-sell/datalayer';
import { isEditPage } from '@classifieds-sell/shared';
import { MotorsDraftFacade, UserFacade } from '@classifieds-sell/state';
import { from, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MotorsSectionBase } from '../motors-section-base';

@Component({
    selector: 'motors-listing-details-contact-section',
    templateUrl: './motors-listing-details-contact-section.component.html',
    styleUrls: ['./motors-listing-details-contact-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MotorsListingDetailsContactSectionComponent
    extends MotorsSectionBase
    implements OnInit, OnDestroy {
    private _destroyed$: Subject<void> = new Subject<void>();
    hasBids: boolean;

    showModal: boolean;

    @ViewChild('motorsListingDetailsContactSectionForm')
    motorsListingDetailsContactSectionForm: NgForm;

    constructor(
        draftFacade: MotorsDraftFacade,
        private _userFacade: UserFacade,
        private _route: ActivatedRoute,
        private _changeDetectorRef: ChangeDetectorRef
    ) {
        super(draftFacade);
    }

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    ngOnInit(): void {
        this.showModal = false;
        super.onInit(() => {
            from(this._userFacade.memberSummary$)
                .pipe(takeUntil(this._destroyed$))
                .subscribe((memberSummary) => {
                    this.draftData.listingDetails.landlineNumber = memberSummary.landlinePhoneNumber;
                    this.draftData.listingDetails.mobileNumber = memberSummary.mobilePhoneNumber;

                    this._changeDetectorRef.markForCheck();
                });
            this.hasBids = this.metadata.bidCount > 0;
        });
    }

    get disableCheckBox(): boolean {
        return isEditPage(this._route)
            && this.draftData.listingDetails.sellingType === SellingTypeEnum.auction
            && this.hasBids;
    }

    isValid(): boolean {
        return true;
    }

    dirty(): boolean {
        return this.motorsListingDetailsContactSectionForm.form.dirty;
    }

    openModal(): void {
        this.showModal = true;
    }

    closeModal(): void {
        this.showModal = false;
    }
}
